import { TCommodityCategory } from '../../../types/commodity';

export const InitializeCommodityCategory = (): TCommodityCategory => ({
  productionId: '',
  isParent: false,
  categoryName: '',
  subCategoryName: '',
});
